import { createAsyncActionTypes } from "../../../../util/async-action-type-creator";

export const GET_COMPANIES = createAsyncActionTypes("GET_COMPANIES__BILLING");
